export default "__VITE_ASSET__BVo5BZeu__"